import { makeActionCreator } from '../../../config/store/utils';
import { batch } from 'react-redux';
import {
  uploadExcelToS3,
  getFilesSubdirectory,
  getGlueMetadata,
} from '../../../services/productivityService';
import { readParquet } from '../../../services/productivityService';

export const UPLOAD_EXCEL_TRIMBLE = 'UPLOAD_EXCEL_TRIMBLE';
export const UPLOAD_EXCEL_TRIMBLE_ERROR = 'UPLOAD_EXCEL_TRIMBLE_ERROR';
export const UPLOAD_EXCEL_TRIMBLE_SUCCESS = 'UPLOAD_EXCEL_TRIMBLE_SUCCESS';
export const onUploadExcelTrimble = makeActionCreator(UPLOAD_EXCEL_TRIMBLE);
export const onUploadExcelTrimbleError = makeActionCreator(
  UPLOAD_EXCEL_TRIMBLE_ERROR,
  'payload'
);
export const onUploadExcelTrimbleSuccess = makeActionCreator(
  UPLOAD_EXCEL_TRIMBLE_SUCCESS,
  'payload'
);
export const onUploadExcelTrimbleThunk = file => async dispatch => {
  dispatch(onUploadExcelTrimble());

  try {
    const result = await uploadExcelToS3(file);

    if (result.status === 'Success') {
      dispatch(onUploadExcelTrimbleSuccess({ key: result.key }));
    } else {
      dispatch(onUploadExcelTrimbleError({ error: result.error }));
    }
  } catch (error) {
    dispatch(onUploadExcelTrimbleError({ error }));
  }
};

export const FETCH_FOLDERS = 'FETCH_FOLDERS';
export const FETCH_FOLDERS_SUCCESS = 'FETCH_FOLDERS_SUCCESS';
export const FETCH_FOLDERS_ERROR = 'FETCH_FOLDERS_ERROR';

export const fetchFolders = makeActionCreator(FETCH_FOLDERS);
export const fetchFoldersSuccess = makeActionCreator(
  FETCH_FOLDERS_SUCCESS,
  'payload'
);
export const fetchFoldersError = makeActionCreator(
  FETCH_FOLDERS_ERROR,
  'payload'
);

// Thunk action to fetch folders based on path
export const fetchFoldersThunk = (path = '') => async dispatch => {
  dispatch(fetchFolders());

  try {
    const response = await getFilesSubdirectory({ path });

    if (response.status === 200) {
      // Clean up each folder name by removing everything before and including the '=' character
      const cleanedFolders = response.data.map(folder =>
        folder.split('=').pop()
      );

      dispatch(fetchFoldersSuccess({ folders: cleanedFolders }));
    } else {
      dispatch(fetchFoldersError('Error fetching folders'));
    }
  } catch (error) {
    dispatch(fetchFoldersError({ error }));
  }
};

const transformJson = inputJson => {
  const { alineacion_partition, partitions } = inputJson;
  return partitions.map((partition, index) => ({
    id: `${index + 1}`, // Unique ID (starting from 1)
    alineacion_partition,
    date_partition: partition.date_partition,
    ...partition.metadata, // Spreading metadata to be at the same level
  }));
};

export const FETCH_SUB_FOLDERS = 'FETCH_SUB_FOLDERS';
export const FETCH_SUB_FOLDERS_SUCCESS = 'FETCH_SUB_FOLDERS_SUCCESS';
export const FETCH_SUB_FOLDERS_ERROR = 'FETCH_SUB_FOLDERS_ERROR';

export const fetchSubFolders = makeActionCreator(FETCH_SUB_FOLDERS);
export const fetchSubFoldersSuccess = makeActionCreator(
  FETCH_SUB_FOLDERS_SUCCESS,
  'payload'
);
export const fetchSubFoldersError = makeActionCreator(
  FETCH_SUB_FOLDERS_ERROR,
  'payload'
);

// Thunk action to fetch folders based on path
export const fetchSubFoldersThunk = (path = '') => async dispatch => {
  dispatch(fetchSubFolders());

  try {
    const response = await getGlueMetadata({ folderPath: path });

    if (response.status === 200) {
      // Clean up each folder name by removing everything before and including the '=' character
      const cleanedFolders = transformJson(response.data);
      dispatch(fetchSubFoldersSuccess({ folders: cleanedFolders }));
    } else {
      dispatch(fetchSubFoldersError('Error fetching folders'));
    }
  } catch (error) {
    dispatch(fetchSubFoldersError({ error }));
  }
};

// Action Types
export const GET_TRIMBLE_DATA = 'GET_TRIMBLE_DATA';
export const GET_TRIMBLE_DATA_ERROR = 'GET_TRIMBLE_DATA_ERROR';
export const GET_TRIMBLE_DATA_SUCCESS = 'GET_TRIMBLE_DATA_SUCCESS';

// Action Creators
export const onGetTrimbleData = makeActionCreator(GET_TRIMBLE_DATA);
export const onGetTrimbleDataError = makeActionCreator(
  GET_TRIMBLE_DATA_ERROR,
  'payload'
);
export const onGetTrimbleDataSuccess = makeActionCreator(
  GET_TRIMBLE_DATA_SUCCESS,
  'payload'
);

// Async action to fetch Trimble data
export const onGetTrimbleDataThunk = (alineation, date) => async dispatch => {
  dispatch(onGetTrimbleData()); // Start loading
  try {
    const type = 'processed_trimble'; // Adjust the type if necessary
    const alineationPartition = `alineation_partition=${alineation}`;
    const datePartition = `date_partition=${date}`;
    const fullPath = `${type}/${alineationPartition}/${datePartition}`;
    console.log(fullPath);
    const response = await readParquet({ type: fullPath });
    const data = JSON.parse(response.data).map((item, index) => {
      return {
        ...item,
        id: `trimble_${index}`,
      };
    });
    dispatch(onGetTrimbleDataSuccess({ data })); // Dispatch success with the data
  } catch (error) {
    dispatch(
      onGetTrimbleDataError({
        error: error.message || 'Error fetching Trimble data',
      })
    ); // Dispatch error
  }
};
